<template>
  <div
    class="items-center hidden py-5 space-x-1 text-xs text-gray-700 md:flex"
    v-if="propertyDetails"
  >
    <button @click="goBack" class="flex">
      <ArrowLeftSvg color="primary" height="4" width="4" />
      <span class="ml-1 text-primary">Back to search</span>
    </button>
    <p class="px-1 text-gray-300">|</p>
    <HomeSvg color="primary" height="3" width="3" />
    <p class="text-gray-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <button
      @click="navigateToProperties(propertyDetails, '', 'Ghana')"
      class="text-primary"
    >
      {{ propertyDetails.property_type.name }}
      <span v-if="propertyDetails.property_tenure_option.name == 'Rent'">
        for rent
      </span>
      <span v-else-if="propertyDetails.property_tenure_option.name == 'Buy'">
        for sale
      </span>
      in Ghana
    </button>
    <p class="text-primary">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <button
      @click="
        navigateToProperties(propertyDetails, propertyDetails.city.name, 'city')
      "
      class="text-primary"
    >
      {{ propertyDetails.city.name }}
    </button>
    <p class="text-gray-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <button
      @click="
        navigateToProperties(propertyDetails, propertyDetails.town.name, 'town')
      "
      class="text-primary"
    >
      {{ propertyDetails.town.name }}
    </button>
    <p class="text-gray-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </p>
    <p class="">{{ propertyDetails.title }}</p>
  </div>
</template>

<script>
import ArrowLeftSvg from "@/components/svg/ArrowLeftSvg";
import { useRouter } from "vue-router";
import HomeSvg from "@/components/svg/HomeSvg.vue";

export default {
  name: "BreadCrumb",
  components: {
    ArrowLeftSvg,
    HomeSvg,
  },
  props: {
    propertyDetails: Object,
  },
  setup() {
    const router = useRouter();

    const navigateToProperties = (propertyDetails, location, locationType) => {
      let tenure_type = "";
      if (propertyDetails.property_tenure_option.name === "Buy") {
        tenure_type = "sale";
      } else if (propertyDetails.property_tenure_option.name === "Rent") {
        tenure_type = "rent";
      } else if (propertyDetails.property_tenure_option.name === "Short Stay") {
        tenure_type = "short-stay";
      } else if (propertyDetails.property_tenure_option.name === "Commercial") {
        tenure_type = "commercial";
      }

      let query = {
        property_type: propertyDetails.property_type.name.toLowerCase(),
      };

      if (locationType === "city") {
        query.city = location.toLowerCase();
      } else if (locationType === "town") {
        query.town = location.toLowerCase();
      }

      router.push({
        name: "properties",
        params: { slug: `properties-for-${tenure_type}` },
        query: query,
      });
    };

    const goBack = () => {
      router.go(-1);
    };
    return { navigateToProperties, goBack };
  },
};
</script>
